const ResetPassword = () => <>Reset Password</>;
export default ResetPassword;
